import * as Location from 'expo-location';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Linking } from 'react-native';

import { Alert } from '@components/Alert';

export const useLocationPermission = () => {
  const { t } = useTranslation();

  const ensureLocationPermission = useCallback(async () => {
    const { status: currentStatus } =
      await Location.getForegroundPermissionsAsync();

    if (currentStatus === 'granted') {
      return true;
    }

    const { status: requestedStatus } =
      await Location.requestForegroundPermissionsAsync();

    return requestedStatus === 'granted';
  }, []);

  // `onCancel` exists for the check-in modal, which is a whole screen the user
  // has nothing to do on without location and so dismisses itself. Every other
  // entry point is a menu row the user can simply not tap again, so the
  // default is a no-op.
  const showLocationPermissionDeniedAlert = useCallback(
    (onCancel?: () => void) => {
      Alert.alert(
        t('models:accessDenied.location.title'),
        t('models:accessDenied.location.message'),
        [
          { text: 'Cancel', style: 'cancel', onPress: () => onCancel?.() },
          {
            text: 'Settings',
            onPress: () => Linking.openSettings(),
          },
        ]
      );
    },
    [t]
  );

  return { ensureLocationPermission, showLocationPermissionDeniedAlert };
};
